import axios from 'axios'

const http = axios.create({
  baseURL: import.meta.env.VITE_APP_API || 'http://localhost:5000/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

function toError(error) {
  const body = error?.response?.data
  const result = new Error(body?.message || error?.message || 'C# function request failed')

  result.httpStatus = error?.response?.status
  result.details = body?.errors || body?.parameter || null

  return result
}

async function post(path, payload) {
  try {
    const response = await http.post(path, payload)
    return response.data
  } catch (error) {
    throw toError(error)
  }
}

export const csharpFunctionApi = {
  validate(payload) {
    return post('api/v1/CSharpFunction/Validate', payload)
  },

  run(payload) {
    return post('api/v1/CSharpFunction/Run', payload)
  },
}

export default csharpFunctionApi
